/**
 * Created by lari on 08/06/2017.
 */

/* either pass list of pdfprinters (patients) to display or load pdfprinters */


(function () {
  'use strict';
  angular.module('vcdms.vcpdfprinter')
    .component('pdfprinterlist', {
      restrict: 'E',
      bindings: {
        pdfprinters: '<?'
      },
      template: `
        <table class="table table-striped">
          <thead>
          <tr>
            <th>Bezeichnung</th>
            <th>Aktion</th>
          </tr>
          </thead>
          <tr ng-repeat="pdfprinter in vm.pdfprinters">
            <td>{{pdfprinter.name}}</td>
            <td>
              <button class="btn btn-primary" ng-click="vm.editPdfprinter(pdfprinter)"><i class="fa fa-edit" uib-tooltip="Editieren"></i></button>
              <button class="btn btn-danger" ng-click="vm.removePdfprinter(pdfprinter)"><i class="fa fa-remove" uib-tooltip="Löschen"></i></button>
            </td>
          </tr>
        </table>
      `,
      controllerAs: 'vm',
      controller: ['$log', '$http', 'Rlog', 'Pdfprinter', 'PdfprinterHelper', 'vertxEventBusService',
        function ($log, $http, Rlog, Pdfprinter, PdfprinterHelper, vertxEventBusService) {
          let vm = this;
          vm.editPdfprinter = PdfprinterHelper.editPdfprinter;
          vm.removePdfprinter = removePdfprinter;
          
          vm.$onInit = function () {
            
            // unless vcclient list has been passed for test purposes, retrieve vcclient list from web
            if (angular.isUndefined(vm.pdfprinters)) {
              vm.pdfprinters = Pdfprinter.$search();
            }
          }; // $onInit()
          
          
          function removePdfprinter(pdfprinter) {
            pdfprinter.active = false;
            pdfprinter.$save();
          }
          
          vertxEventBusService.on('pdfprinters.update', function (message) {
            $log.debug('debug: pdfprinter update received: ', message);
            vm.pdfprinters.$refresh().$then(function () {
              $log.debug('debug: pdfprinterlist refreshed pdfprinters');
            }, function (error) {
              $log.debug('debug: pdfprinterlist refresh pdfprinters failed: ', error);
            });
          });
          
          
          
          
        }] // controller
    }); // component
  
  // klammerfriedhof
}());
